import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

import {CheckStatus} from './reducers'

export const BasicProcessArray = [
  '基础信息',
  '关键信息',
  '邀请主播',
  '成功入驻',
]
// overtime = -1000, // -1000超时·未继续，开通失败
// invalid = -3, // -3已失效
// rejected = -2, // -2已拒绝
// toBeConfirm = -1, // -1待确认
// confirm = 1, // 1已确认

// basicUnfilled = 2, // 2基本信息·未填写
// basicUnChecked = 3, // 3基本信息·待审核
// basicFail = 4, // 4基本信息·不符合，开通失败
// detailUnfilled = 5, // 5详细信息·未填写
// detailUnchecked = 6, // 6详细信息·待审核
// detailBack = 7, // 7详细信息·已驳回 重新填写
// detailChat = 8, // 8详细信息·沟通中
// detailFail = 9, // 9详细信息·不符合，开通失败
// inviting = 10, // 10邀请主播·邀请中
// success = 1000, // 1000开通成功

export const getAppCode = (hAreaCode) => {
  switch (hAreaCode) {
    case hAreaCodeEnum.vi:
      return {title: '基础信息-公会长聊天软件-Zalo-标题', value: 'Zalo'}
      break
    case hAreaCodeEnum.th:
      return {title: '基础信息-公会长聊天软件-Line-标题', value: 'Line'}
    default:
      return {title: '基础信息-公会长聊天软件-WhatsApp-标题', value: 'WhatsApp'}
      break
  }
}

// 阶段判断 根据状态码  返回当前状态
export const getCurrentStatus = (status) => {
  switch (status) {
    case 2:
      return {currentStep: 1, curStatus: CheckStatus.commit} // 基础信息未填写
      break
    case 3:
      return {currentStep: 1, curStatus: CheckStatus.check} // 基础信息待审核
      break
    case 4:
      return {currentStep: 1, curStatus: CheckStatus.fail} // 基础信息填写失败
      break
    case 5:
      return {currentStep: 2, curStatus: CheckStatus.commit} // 详细信息基础信息未填写
      break
    case 6:
      return {currentStep: 2, curStatus: CheckStatus.check} // 详细信息待审核
      break
    case 7:
      return {currentStep: 2, curStatus: CheckStatus.back} // 详细信息驳回修改
      break
    // case 8:
    //   return {currentStep: 2, curStatus: CheckStatus.fail} // 详细信息沟通中
    //   break
    case 9:
      return {currentStep: 2, curStatus: CheckStatus.fail} // 详细信息填写失败
      break
    case 10:
      return {currentStep: 3} // 邀请主播中
      break
    default:
      return {currentStep: 1, curStatus: CheckStatus.commit}
      break
  }
}

export const AllAreaOptions = [
  {text: '中东', value: 0},
  {text: '印尼', value: 1},
  {text: '越南', value: 2},
  {text: '菲律宾', value: 3},
  {text: '新马', value: 4},
  {text: '泰国', value: 5},
  {text: '印度', value: 6},
  {text: '巴基斯坦', value: 7},
  {text: '土耳其', value: 8},
  {text: '海外华语', value: 9},
  {text: '英语一区', value: 10},
  {text: '巴西', value: 11},
]

// 合作过的应用
export const CoopAppOptions = {
  [hAreaCodeEnum.ar]: [
    'Yoyo',
    'Yoho',
    'Hago',
    'Soulchill',
    'Ahlan',
    'Sawa',
    'Kafu',
    'Mico',
    'Bigo',
    'Uplive',
    '4 fun',
    'Starchat',
    'Partying',
    'Party star',
    'Hello yo',
    'Lama',
    'Poppo live',
    'Whisper',
    'Likee',
    'Sango',
    'Yalla',
    'Hawa',
    'Ligo live',
  ],
  [hAreaCodeEnum.tr]: [
    'Yoho',
    'Soulchill',
    'Starchat',
    'Yalla',
    'Litmatch',
    'Mico',
    'Bigo',
    'StarMaker',
    'Yoyo',
    'Party',
    'Star',
    'Voga',
    'Sango',
  ],
  [hAreaCodeEnum.hi]: [
    'YoyoYoho',
    'Oyetalk',
    'AhlanMigo',
    'Live',
    'SangoWafaStarMakerUme',
    'Hello',
    'yo',
    'yalla',
  ],
  [hAreaCodeEnum.pk]: [
    'Yoyo',
    'Yoho',
    'Oyetalk',
    'Ahlan',
    'Migo Live',
    'Sango',
    'Wafa',
    'StarMaker',
    'Ume',
    'Hello yo',
    'yalla',
  ],
  [hAreaCodeEnum.id]: [
    'Hago',
    'Partying',
    'Yoyo',
    'Hello yo',
    'StarMaker',
    'lemo',
    'Ola chat',
    'Oohla',
    'Light chat',
    'Bigo',
    'Uplive',
    'Starchat',
    'Sango',
  ],
  [hAreaCodeEnum.vi]: [
    'Hago',
    'Partying',
    'Yoho',
    'Hello yo',
    'StarMaker',
    'Yoyo',
    'Soulchill',
    'Alo Party',
    'Light chat',
    'Ohhla',
  ],
  [hAreaCodeEnum.th]: [
    'Hago',
    'Partying',
    'Yoho',
    'Hello yo',
    'StarMaker',
    'Yoyo',
    'Soulchill',
    'Alo Party',
    'Light chat',
    'Ohhla',
  ],
  [hAreaCodeEnum.tp]: [
    'Lightchat',
    'Uplive',
    'StarMaker',
    'Hago',
    'Calamansi',
    'Partying',
    'Poppo',
  ],
  [hAreaCodeEnum.ms]: ['YY', '斗鱼', '虎牙', '玩吧', 'BiliBili'],
  [hAreaCodeEnum.hk]: ['YY', '斗鱼', '虎牙', '玩吧', 'BiliBili'],
}

// 对应区域隐藏内容 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105306073
// 中东改变 ： http://wiki.xunlei.cn/pages/viewpage.action?pageId=117026311
// area 公会区域
// appWork 是否跟其他应用合作过
// unionNumber 公会初期可入驻主播数
// WhatsApp 常用WhatsApp账号
// mark 备注
// appId 您在该应用的ID
// personImg 您在该应用上的个人主页截图
// anchorCenter 您在该应用上的公会/主播中心主页截图
// unionCenter 进入公会中心录屏
// incom 在该平台是否达到收入标准
// topTitle 1～2～3～4标题
export const hideContent = {
  [hAreaCodeEnum.ar]: {
    // unionNumber: true,
    incom: true,
    anchorCenter: true,
    unionCenter: true,
  },
  [hAreaCodeEnum.tr]: {
    incom: true,
    anchorCenter: true,
    unionCenter: true,
  },
  [hAreaCodeEnum.vi]: {
    topTitle: true,
  },
  [hAreaCodeEnum.id]: {
    topTitle: true,
  },
  [hAreaCodeEnum.th]: {
    topTitle: true,
  },
  [hAreaCodeEnum.tp]: {
    topTitle: true,
  },
  [hAreaCodeEnum.hi]: {
    incom: true,
  },
  [hAreaCodeEnum.pk]: {
    incom: true,
    anchorCenter: true,
    unionCenter: true,
  },
  [hAreaCodeEnum.ms]: {},
  [hAreaCodeEnum.hk]: {},
}

// 邀请页图片链接 一替换habi
export const inviteImg = {
  [hAreaCodeEnum.ar]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.id]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.tr]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.vi]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.th]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.tp]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.hi]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.pk]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.ms]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
  [hAreaCodeEnum.hk]: [
    `${HostMaps.prod.img01}/img/png/id/37874586`,
    `${HostMaps.prod.img01}/img/png/id/37874471`,
    `${HostMaps.prod.img01}/img/png/id/37874449`,
  ],
}

export const inviteTopImg = {
  [hAreaCodeEnum.ar]: `${HostMaps.prod.img01}/img/png/id/93621137238`,
  [hAreaCodeEnum.id]: `${HostMaps.prod.img01}/img/png/id/93621137647`,
  [hAreaCodeEnum.tr]: `${HostMaps.prod.img01}/img/png/id/93621137519`,
  [hAreaCodeEnum.vi]: `${HostMaps.prod.img01}/img/png/id/93621137935`,
  [hAreaCodeEnum.th]: `${HostMaps.prod.img01}/img/png/id/93621137397`,
  [hAreaCodeEnum.tp]: `${HostMaps.prod.img01}/img/png/id/93621137730`,
  [hAreaCodeEnum.hi]: `${HostMaps.prod.img01}/img/png/id/93621137730`,
  [hAreaCodeEnum.pk]: `${HostMaps.prod.img01}/img/png/id/93621137730`,
  [hAreaCodeEnum.ms]: `${HostMaps.prod.img01}/img/png/id/93621137730`,
  [hAreaCodeEnum.hk]: `${HostMaps.prod.img01}/img/png/id/93621137730`,
}
